import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators'
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {ClienteService} from '../../services/cliente.service';
import {MaterialService} from '../../services/material.service';
import {PorcentajeMermaAsigClienteService} from '../../services/porcentaje-merma-asig-cliente.service';
import { InputSearchService } from 'src/app/aplicaciones-modulos/financiero/services/inputSearch/input-search.service';
import { CobrosAutoserviciosService } from 'src/app/aplicaciones-modulos/financiero/services/cobrosAutoservicio/cobros-autoservicios.service';

@Component({
  selector: 'app-porcentaje-merma-asig-client',
  templateUrl: './porcentaje-merma-asig-client.component.html',
  styleUrls: ['./porcentaje-merma-asig-client.component.css']
})
export class PorcentajeMermaAsigClientComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.mantMermaAsigClient;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;

  formularioModal: FormGroup;

  rowDataModal             : any[] = [];
  rowSelectionModal        : string;
  columnDefsModal          : any;
  frameworkComponentsModal : any;
  
  mostrar: boolean;

  public agregarForm = new FormGroup({
    id: new FormControl(null),
    porcMerma: new FormControl(null, [Validators.maxLength(17)]),
    precioUni: new FormControl(null, [Validators.maxLength(17)]),
    undPrecioVenta: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z]+$/), Validators.maxLength(3)]),
    cliente: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/), Validators.maxLength(13)]),
    nombrecliente: new FormControl(null, [Validators.required]),
    material: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/), Validators.maxLength(10)]),
    nombrematerial: new FormControl(null, [Validators.required]),
  });
  public materialValid: boolean = false;
  private subscription = new Subscription();

  constructor(
    public fb: FormBuilder,
    private _util: UtilsService,
    private porcentajeMermaAsigClienteS: PorcentajeMermaAsigClienteService,
    private materialService: MaterialService,
    private clienteService: ClienteService,
    private _cobrosAutoservicios: CobrosAutoserviciosService,
    private _inputSearchService: InputSearchService,
  ) {
  }

  ngOnInit() {
    this.girdComponent();
    this.obtenerTodo();
    this.cargarComponentesModal();
    this.subscription.add(
      this.agregarForm.get('cliente').valueChanges
        .pipe(debounceTime(1000))
        .subscribe(
          resp => {
            if (resp) {
              this.getClienteById(resp);
            }
          }
        )
    );

    this.formularioModal = this.fb.group({
      codigo1: ['', [Validators.required]],
      codigo2: ['', [Validators.required]],
      ruc1: ['', [Validators.required]],
      ruc2: ['', [Validators.required]],
      nombre: ['', [Validators.required]]
    });

    this.subscription.add(
      this.agregarForm.get('material').valueChanges
        .pipe(debounceTime(1000))
        .subscribe(
          resp => {
            if (resp) {
              this.getMaterialById(resp);
            }
          }
        )
    );
  }

  getClienteById(codCliente: string) {
    this.subscription.add(
      this.clienteService.obtenerPorId(codCliente).subscribe(
        resp => {
          if (!resp) {
            this._util.mensajeErroToast('No se encontró el cliente.');
            this.agregarForm.get('nombrecliente').setValue('');
            return;
          }
          this.agregarForm.get('nombrecliente').setValue(resp.idCliente +' - '+resp.nombreCliente1);
        },
        error => {
          this._util.mensajeErroToast('No se encontró el cliente.');
          this.agregarForm.get('nombrecliente').setValue('');
        }
      )
    );
  }

  getMaterialById(codMaterial: string) {

    this.materialValid = false;

    this.subscription.add(
      this.materialService.obtenerPorId(codMaterial).subscribe(
        resp => {
          if (!resp) {
            this._util.mensajeErroToast('No se encontró el material.');
            this.agregarForm.get('nombrematerial').setValue('');
            return;
          }
          this.agregarForm.get('nombrematerial').setValue(resp.idMaterial +' - '+ resp.dscaMaterial);
          this.materialValid = true;
        },
        error => {
          this._util.mensajeErroToast('No se encontró el material.');
          this.agregarForm.get('nombrematerial').setValue('');
        }
      )
    );
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Secuencial',
        field: 'id',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Cliente',
        field: 'cliente',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Material',
        field: 'material',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Precio Unitario',
        field: 'precioUni',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Porcentaje merma',
        field: 'porcMerma',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 55,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      }
    ];
  }

  obtenerTodo() {
    this.loading = true;
    this.subscription.add(
      this.porcentajeMermaAsigClienteS.obtener().subscribe(
        (resp) => {
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  guardarCrearNueva() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        action: this.DAT_BTNS.nuevo,
        funcion: this.porcentajeMermaAsigClienteS.crear(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarEditar() {
    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        action: this.DAT_BTNS.editar,
        funcion: this.porcentajeMermaAsigClienteS.actualizar(
          data
        ),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarForm.reset();
    this.openModal();
  }

  editar({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.agregarForm.patchValue(rowData);
    this.cargarCliente({});
    this.openModal();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
    if (!this.isCreate) this.guardarEditar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  cargarCliente($event) {
    let idCliente = this.agregarForm.get('cliente').value;
    this.getCliente(idCliente);
  }

  getCliente(idCliente) {
    this._cobrosAutoservicios.getCliente(idCliente).subscribe((resp: any) => {
      this.agregarForm.get('nombrecliente').setValue(resp.nombreCliente1);
    }, (err) => {
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  modalBuscarCLiente = false;
  callModal(target) {
    this.modalBuscarCLiente = true;
  }
  closeModalBuscarCLiente() {
    this.modalBuscarCLiente = false;
  }

  mostrarTabla() {
    this.loading = true;
    this.mostrar = true;
    let codIni = this.formularioModal.get('codigo1').value;
    let codFin = this.formularioModal.get('codigo2').value;
    let rucIni = this.formularioModal.get('ruc1').value;
    let rucFin = this.formularioModal.get('ruc2').value;
    let nombre = this.formularioModal.get('nombre').value;
    this._inputSearchService.getClienteParams(codIni, codFin, rucIni, rucFin, nombre).subscribe((res: any) => {
      this.rowDataModal = res;
      this.loading = false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowDataModal = [];
    });
  }
  mostrarFormularioMethod() {
    this.mostrar = false;
    this.formularioModal.setValue({
      codigo1: '',
      codigo2: '',
      ruc1: '',
      ruc2: '',
      nombre: ''
    });
  }
  cargarComponentesModal() {
    this.formularioModal = this.fb.group({
      codigo1: ['', [Validators.required]],
      codigo2: ['', [Validators.required]],
      ruc1: ['', [Validators.required]],
      ruc2: ['', [Validators.required]],
      nombre: ['', [Validators.required]]
    });

    this.frameworkComponentsModal = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsModal = [
      {
        headerName: 'ID',
        field: 'idCliente',
        sortable: true,
        // checkboxSelection: true,
        // headerCheckboxSelection: true,
        width: 150,
        filter: true,
      },
      {
        headerName: 'RUC',
        field: 'rucCliente',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'NOMBRE CLIENTE',
        field: 'nombreCliente1',
        width: 400,
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 200,
        cellRendererParams: {
          onClick: this.selectLinea.bind(this),
          label: 'Seleccionar',
          colorBoton: 'btn btn-info'
        }
      }
    ];
    this.rowSelectionModal = 'multiple';
    this.rowDataModal = [];
  }
  selectLinea({ rowData }) {
    // this.mostrar = false;
    // // this.closebutton.nativeElement.click();
    // this.value = rowData.descripcion;
    // //this.devolverAccion.emit(rowData.idCliente);
    // this.devolverAccion.emit(rowData);
    this.agregarForm.get('cliente').setValue(rowData.idCliente);
    this.cargarCliente({});
    this.modalBuscarCLiente = false;
  }


}
